import { isUsDomesticIcao } from "./akhiIcao";

/**
 * Whether **international facility tax (IRS No. 27)** may use `intl_pax` for this route geometry.
 *
 * - **US ↔ non-US** (one endpoint US domestic ICAO, one not): international for this purpose.
 * - **US ↔ US**: domestic only here — stored `intl_pax` does not apply to intl facility.
 * - **Non-US ↔ non-US**: does not count — stored `intl_pax` is ignored for intl facility.
 *
 * US domestic ICAO: contiguous `K…`, Alaska `PA…`, Hawaii `PH…` (see `isUsDomesticIcao`).
 * Territories outside those prefixes are treated as non-US until expanded.
 */
export function isInternationalFacilityRoute(
  fromIcao: string,
  toIcao: string
): boolean {
  return isUsDomesticIcao(fromIcao) !== isUsDomesticIcao(toIcao);
}

/**
 * **Non-US ↔ non-US** (neither endpoint is US domestic ICAO). IRS No. 27 does not use
 * <code>intl_pax</code> here; IRS No. 26 domestic segment is 0 — <code>passenger_count</code> is ignored;
 * use explicit <code>dom_pax</code> override when needed.
 */
export function isForeignForeignAirLeg(fromIcao: string, toIcao: string): boolean {
  return !isUsDomesticIcao(fromIcao) && !isUsDomesticIcao(toIcao);
}
